import { LobbyCheckIn } from './../shared/models/lobby-check-in';
import { StaffMember } from './../shared/models/staff-member';
import { Observable, Subscription } from 'rxjs';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, OnChanges, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { getIsInstantAssistSuccess, getIsLocationChanged, getLobbyCheckIn, getServiceFilterValue, getServices, getShowLobbyCheckInPopup, getSpanishSpeakerPreferred, getStaffMembers, State } from './state';
import * as LobbyCheckInPageActions from './state/actions/lobby-check-in-page.actions';
import { getIsConnectionStarted, getLobbyLocationSelctorStatus, getLobbyLocationSelected, getLoggedInUserInfo, getSignedInStatus, getSystemConfigurations } from 'src/app/state';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericValidator } from 'src/app/shared/validators/generic-validator';
import { formatDate } from '@angular/common';
import { DialogAction, DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { ModalPopupImplComponent } from 'src/app/shared/modalpopup/modal-popup-impl/modal-popup-impl.component';
import * as LobbyWrapUpPageActions from '../lobby-wrap-up/state/actions/wrap-up-page.actions';
import { Router } from '@angular/router';
import { LobbyConfiguration } from '../shared/models/lobby-configuration';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';
import LobbyTab from '../shared/models/lobby-tab';
import { take } from 'rxjs/operators';
import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';
import { UserSigninStatus } from 'src/app/shared/enums/UserSigninStatus.enum';
import { LocationSelector } from 'src/app/shared/models/location-selector/location-selector-model';
import EmailValidator from 'src/app/shared/validators/generic-email-validator';
import { MaskingType } from 'src/app/shared/enums/mskingType';
import { FixedNumberOfCharsMaskedFromEnd, Masker } from 'src/app/shared/masking/partial-masking';
import * as LobbyStaffStatusActions from '../lobby-staff-status/state/actions/lobby-staff-status.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { readCastedValue } from 'src/app/shared/utils/read-casted-value.function';

@Component({
  selector: 'app-lobby-check-in',
  templateUrl: './lobby-check-in.component.html',
  styleUrls: ['./lobby-check-in.component.scss']
})
export class LobbyCheckInComponent implements OnInit, OnDestroy, OnChanges {
  public _locationId: number = 0;
  private _tenantId: number = 0;
  public _locationName: string = '';
  private _timezoneId: string = '';
  lobbyCheckInComponentSubscriptions: Subscription = new Subscription();
  public _dialogOpened: boolean = false;

  staffMembers$: Observable<StaffMember[]> = new Observable<StaffMember[]>();
  lobbyServices$: Observable<any[]> = new Observable<any[]>();
  lobbyServices: any[] = [];
  spanishSpeakerPrefferChecked$: Observable<boolean> = new Observable<boolean>();
  lobbyConfiguration: LobbyConfiguration = <LobbyConfiguration>{};
  staffMemberRequiredMessage: string | null = null;
  public currentLobbyEntry: any = null;
  lobbyCheckInForm: FormGroup;
  lobbyCheckIn: LobbyCheckIn = <LobbyCheckIn>{};
  isUserSigned: boolean = false;
  disableSelector: boolean = false;
  sorted: boolean = false;
  sortdedAscending: boolean = false;
  impersonateInstantAssist: boolean = false;
  serviceFilterValue: string = '';
  currentDate = new Date();
  dateSelectionMaxLimit = formatDate(this.currentDate.setDate(this.currentDate.getDate() - 3), 'yyyy-MM-dd', 'en');
  isAccountMemberPopupVisible: boolean = false;
  popupTitile: string = '';
  // Use with the generic validation message class
  displayMessage: { [key: string]: string } = {};
  private validationMessages?: { [key: string]: { [key: string]: string } };
  private genericValidator!: GenericValidator;
  private accountNumberValue: string = "";
  private isSpanishSpeakerPrefered: boolean = false;
  public selectedLocationName: string = '';
  public selectedLocationId: number = 0;
  public enableUserImpersonation: boolean = false;
  public enableUserImpersonationForTenant: boolean = false;
  public impersonateByName: string = '';
  public visitorCheckInSubTitle:string = '';
  public visitorCheckInTitle:string = '';
  public signinForAssistText:string = '';
  public staffMemberRequirdText:string = '';
  public signinInstantlyAssistText:string = '';
  public lobbyCheckInSigninForAssistText:string = '';
public isAssisting:boolean=false;
  
  @ViewChild('lobbyCheckinModal') public modal: any;
  @Input() set dialogOpened(value: boolean) {
    this._dialogOpened = value;
    if (value == true) {

      this.visitorCheckInSubTitle=this.translateService.instant('_Lobby_Visitor_Check_In_Ts_Text_');
      this.visitorCheckInTitle=this.translateService.instant('_Lobby_Visitor_Check_In_Ts_Text_');
      this.signinForAssistText=this.translateService.instant('_Lobby_CheckIn_Signin_For_Assist_Text_');
      this.signinInstantlyAssistText=this.translateService.instant('_Lobby_CheckIn_Instantly_Assist_Record_Text_');
      this.lobbyCheckInSigninForAssistText=this.translateService.instant('_Lobby_CheckIn_Signin_For_Assist_Text_');
      this.staffMemberRequirdText=this.translateService.instant('_General_Staff_Memeber_Required_Ts_Text_');
      this.setPopupTitle();
    }
  }
  get dialogOpened(): boolean {
    return this._dialogOpened;
  }
  @Input() public enableTextMessages: boolean = false;
  @Input() set locationId(value: number) {
    if (value && value > 0) {
      this._locationId = value;
      this.store.dispatch(LobbyCheckInPageActions.setLocationId({ locationId: value }));
    }
  }
  get locationId(): number {
    return this._locationId;
  }
  @Input() set timezoneId(value: string) {
    if (value && value != null) {
      this._timezoneId = value;
      this.store.dispatch(LobbyCheckInPageActions.setTimezoneId({ timezoneId: value }));
    }
  }
  get timezoneId(): string {
    return this._timezoneId;
  }
  @Input() set locationName(value: string) {
    if (value && value != null) {
      
      this._locationName = value;
      
    }
  }
  get locationName(): string {
    return this._locationName;
  }
  @Input() set tenantId(value: number) {
    if (value && value > 0) {
      this._tenantId = value;
      this.loadStaffMembers();
    }
  }
  get tenantId(): number {
    return this._tenantId;
  }
  @Input() public signInUserId: number = 0;
  @Output() public cancelled = new EventEmitter();
  @Output() public dialogOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  private masker: Masker = new Masker();
  
  constructor(private store: Store<State>, private fb: FormBuilder, private dialogService: DialogService, private router: Router, private translationLoaderFacade: TranslationLoaderFacade, private translateService: TranslateService, private cdr: ChangeDetectorRef, private appRef: ApplicationRef) {

    // this.GenericValidator();
    this.lobbyCheckInForm = this.fb.group({
      AccountNumber: ['', Validators.pattern(/^[^<>&]+$/)],
      FirstName: ['', [Validators.required, Validators.pattern(/^[^<>&]+$/)]],
      LastName: ['', [Validators.required, Validators.pattern(/^[^<>&]+$/)]],
      DateOfBirth: '',
      Notes: ['', Validators.pattern(/^[^<>&]+$/)],
      PhoneNumber: ['', Validators.pattern(/^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/)],
      EmailAddress: ['', EmailValidator()],
      CustomFieldValues: [''],
      PreferredLanguage: 1,
      RecieveTextMessage: false,
      UserRequested: '-1'
    });

  }

  ngOnInit() {
    this.impersonateInstantAssist = false;
    this.masker = new Masker();
    this.masker.setStrategy(new FixedNumberOfCharsMaskedFromEnd(4));

    this.staffMembers$ = this.store.select(getStaffMembers);
    this.spanishSpeakerPrefferChecked$ = this.store.select(getSpanishSpeakerPreferred);

    this.setPopupTitle();
   
    this.lobbyCheckInComponentSubscriptions.add(
      this.store.select(getSystemConfigurations).subscribe(
        (configurations) => {
          const lobbyConfigurations = configurations.filter(c => c.configurationGroup === 'LobbySettings');
          if (lobbyConfigurations.length > 0) {
            
            // FIXME check if there is a better way to assigned value from readCastedValue method instead of using type casting.
            this.lobbyConfiguration = {
              EnableAccountNumber: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableAccountNumber')) as boolean,
              AccountNumberMaskingOption: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'AccountNumberMaskingOption')) as string,
              EnablePhoneNumber: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnablePhoneNumber')) as boolean,
              EnableEmailAddress: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableEmailAddress')) as boolean,
              EnableDateOfBirth: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableDateOfBirth')) as boolean,
              EnableCustomField: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableCustomField')) as boolean,
              EnabledSmsNotificationTypes: [],
              CommentsRequired: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'CommentsRequired')) as boolean,
              ShowCategoriesInLobby: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'ShowCategories')) as boolean,
              EnableReferenceNumber: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableReferenceNumber')) as boolean,
              MakeStaffMemberSelectionMandatory: readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'MakeStaffMemberSelectionMandatory')) as boolean,
              CustomFieldText: readCastedValue(lobbyConfigurations.find(x => x.configurationName == 'CustomFieldText')) as string,
              AccountNumberDisplayText: readCastedValue(lobbyConfigurations.find(x => x.configurationName == 'AccountNumberDisplayText')) as string,
              EnableTextMessageNotification: readCastedValue(configurations.find(x => x.configurationName == 'EnableTextMessageNotification')) as boolean,

            };
            this.enableUserImpersonationForTenant = readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableUserImpersonation')) as boolean;
            this.GenericValidator();
            this.lobbyServices$ = this.store.select(getServices(this.lobbyConfiguration.ShowCategoriesInLobby));
            this.store.select(getServices(this.lobbyConfiguration.ShowCategoriesInLobby)).subscribe(
              services => {
                this.lobbyServices = services;
              }
            );
          }

        }
      )
    );

    this.SetDynamicValidation();

    this.lobbyCheckInForm.controls.RecieveTextMessage.disable();

    // Watch for value changes for validation
    // const validationSubscription = this.lobbyCheckInForm.valueChanges.subscribe(
    //   () => this.displayMessage = this.genericValidator.processMessages(this.lobbyCheckInForm)
    // );

    const StaffSelectionSubscription = this.lobbyCheckInForm.controls.UserRequested.valueChanges.subscribe(
      (value) => {
        if (value !== '-1') {
          this.staffMemberRequiredMessage = null;
        }
        this.doStaffValidation();
      }
    );

    const serviceFilterSubscription = this.store.select(getServiceFilterValue).subscribe(
      value => {
        this.serviceFilterValue = value;
      }
    );
    const showLobbyCheckInPopupSubscriptions = this.store.select(getShowLobbyCheckInPopup).subscribe(
      (showLobbyCheckIn) => {
        if (!showLobbyCheckIn) {
          this.accountNumberValue = '';
        }

      }
    );

    const signalRConnectionSubscription = this.store.select(getIsConnectionStarted).subscribe(
      isHubConnected => {
        if (isHubConnected) {
          console.log('lobby received hub connected');
          this.loadStaffMembers();
        }
      });

    const locationChangeSubscription = this.store.select(getIsLocationChanged).subscribe(
      isLocationChanged => {
        if (isLocationChanged && this._dialogOpened) {

          this.store.dispatch(LobbyCheckInPageActions.loadLobbyDetails({ locationId: this.locationId }));
          this.loadStaffMembers();
          this.store.dispatch(LobbyCheckInPageActions.loadServices({ locationId: this.locationId, showInLobby: true, showCategory: this.lobbyConfiguration.ShowCategoriesInLobby }));

        } else {

        }
      }
    );

    const lobbyCheckInSubscription = this.store.select(getLobbyCheckIn).subscribe(
      lobbyCheckIn => {
        this.displayMessage={};
        this.lobbyCheckIn = lobbyCheckIn;

        if (lobbyCheckIn.lobbyEntryId > 0 || lobbyCheckIn.lobbyEntryId === -1) {
          this.staffMemberRequiredMessage = null;
          this.lobbyCheckInForm.reset();

          this.lobbyCheckInForm.patchValue({
            AccountNumber: lobbyCheckIn.AccountNumber,
            FirstName: lobbyCheckIn.FirstName,
            LastName: lobbyCheckIn.LastName,
            DateOfBirth: lobbyCheckIn.DateOfBirth,
            Notes: lobbyCheckIn.Notes,
            PhoneNumber: lobbyCheckIn.PhoneNumber,
            EmailAddress: lobbyCheckIn.EmailAddress,
            CustomFieldValues: lobbyCheckIn.CustomFieldValues[1],
            PreferredLanguage: 1,
            RecieveTextMessage: false,
            UserRequested: '-1'
          });

          this.lobbyCheckInForm.controls.RecieveTextMessage.disable();
          this.lobbyCheckInForm.controls.RecieveTextMessage.setValue(false);
        }

        if (lobbyCheckIn.lobbyEntryId === -1) {
          this.store.dispatch(LobbyCheckInPageActions.readyForTheNextCheckIn());
        }
        this.doStaffValidation();

      }
    );

    const instantAssistSuccessSubscription = this.store.select(getIsInstantAssistSuccess).subscribe(
      instantAssistedLobbyEntryId => {
        if (instantAssistedLobbyEntryId !== null) {
          this.store.dispatch(LobbyWrapUpPageActions.assistLobbyEntry({
            lobbyEntryId: instantAssistedLobbyEntryId,
            assistingUserId: this.signInUserId,
            isInstantAssist: true,
            locationId: this.locationId,
            showLobbyCategory: this.lobbyConfiguration.ShowCategoriesInLobby,
            isImpersonateAssist: this.impersonateInstantAssist,
            impersonateByName: this.impersonateByName
          }));
          this.close();
        }
      }
    );
    const spanishSpeakerSubscription = this.store.select(getSpanishSpeakerPreferred).subscribe(
      isSpanishSpeakerPrefered => {
        this.isSpanishSpeakerPrefered = isSpanishSpeakerPrefered;
        if (this.isSpanishSpeakerPrefered) {
          this.lobbyCheckInForm.patchValue({
            PreferredLanguage: 3,
          });
        } else {
          this.lobbyCheckInForm.patchValue({
            PreferredLanguage: 1,

          });
        }

      }
    );
    const locationSubscription = this.store.select(getLobbyLocationSelected).subscribe((location) => {
      this.selectedLocationId = location.locationId;
      this.selectedLocationName = location.locationName;
      this.disableSelector = location.dropDownDisabled;
      this.setPopupTitle();

    });
    this.lobbyCheckInComponentSubscriptions.add(this.store.select(getLoggedInUserInfo).subscribe((userInfo) => {
      if (userInfo != null) {
        this.enableUserImpersonation = userInfo.enableUserImpersonation;
      }

    }));

     const locationSelectorStatusSubscription=this.store.select(getLobbyLocationSelctorStatus).subscribe(status => {
          if(status!=undefined){
            if(this.isUserSigned && status.isError){
             
              this.isAssisting=status.isAssisting;
             
            }
           else{
              this.isAssisting=false;
            }
      
          }
             
          });



    this.lobbyCheckInComponentSubscriptions.add(serviceFilterSubscription);
    this.lobbyCheckInComponentSubscriptions.add(signalRConnectionSubscription);
    this.lobbyCheckInComponentSubscriptions.add(locationChangeSubscription);
    this.lobbyCheckInComponentSubscriptions.add(lobbyCheckInSubscription);
    this.lobbyCheckInComponentSubscriptions.add(instantAssistSuccessSubscription);
    this.lobbyCheckInComponentSubscriptions.add(spanishSpeakerSubscription);
    this.lobbyCheckInComponentSubscriptions.add(locationSubscription);
    this.lobbyCheckInComponentSubscriptions.add(showLobbyCheckInPopupSubscriptions);
    this.lobbyCheckInComponentSubscriptions.add(locationSelectorStatusSubscription);

  }

  convertInvalidDate(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const enteredDate = inputElement.value;
    const minDate = '1900-01-01';

    if (enteredDate < minDate) {
      inputElement.value = minDate;
    }
    if (enteredDate > this.dateSelectionMaxLimit) {
      inputElement.value = this.dateSelectionMaxLimit;
    }
  }

  setPopupTitle() {
    const signinStatusSubscription = this.store.select(getSignedInStatus)
       .subscribe((status: any) => {
        if (status && (status.statusId === UserSigninStatus.Idle || status.statusId === UserSigninStatus.Assisting))
        {
          this.popupTitile= this.visitorCheckInSubTitle+' '+this.locationName;
          this.isUserSigned=true;
        }
        else{
          this.popupTitile=this.visitorCheckInTitle;
          this.isUserSigned=false;
        }

      });
    this.lobbyCheckInComponentSubscriptions.add(signinStatusSubscription);
  }
  onLocationsFetched(locations: LocationSelector) {
    const locationSubscription = this.store.select(getLobbyLocationSelected).pipe(take(1)).subscribe((location) => {
      this.selectedLocationId = location.locationId;
      this.selectedLocationName = location.locationName;
      this.disableSelector = location.dropDownDisabled;

    });

  }
  public handleLocationData(locaitonSelectorData: LocationSelectorInfo): void {
    this.selectedLocationId = locaitonSelectorData.id ?? 0;
    this.selectedLocationName = locaitonSelectorData.locationName;
    this._locationId = locaitonSelectorData.id ?? 0;
    this.store.dispatch(LobbyCheckInPageActions.setLocationId({ locationId: this._locationId }));

  }
  OnUserSelected(eventData: { name: string }) {
    this.impersonateByName = eventData.name;

  }

  ngOnDestroy(): void {
    this.lobbyCheckInComponentSubscriptions.unsubscribe();
    this.impersonateInstantAssist = false;
  }

  // Also validate on blur
  // Helpful if the user tabs through required fields
  blur(): void {
    this.displayMessage = this.genericValidator.processMessages(this.lobbyCheckInForm);
  }

  serviceCheckBoxClick(serviceId: number) {
    if (!this.lobbyCheckIn.ServiceRequested.includes(serviceId)) {
      this.store.dispatch(LobbyCheckInPageActions.serviceCheckboxChecked({ serviceId }));
    } else {
      this.store.dispatch(LobbyCheckInPageActions.serviceCheckboxUnchecked({ serviceId }));
    }
    if (this.sorted) {
      this.sortServicesClick();
    }


  }

  spanishSpeakerCheckBoxClick(event: Event) {
    const target = event.target as HTMLInputElement;
    this.store.dispatch(LobbyCheckInPageActions.spanishSpeakerPreferredChange({ spanishSpeakerPreferred: target.checked }));
  }

  serviceFilter() {
    this.store.dispatch(LobbyCheckInPageActions.serviceFilterValueChange({ filterValue: this.serviceFilterValue }));
  }

  serviceFilterKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' || this.serviceFilterValue === '') {
      this.store.dispatch(LobbyCheckInPageActions.serviceFilterValueChange({ filterValue: this.serviceFilterValue }));
    }
  }

  clearServiceFilterWhenEmpty() {
    if (this.serviceFilterValue === '') {
      this.store.dispatch(LobbyCheckInPageActions.serviceFilterValueChange({ filterValue: this.serviceFilterValue }));
    }
  }

  clearServiceFilter() {
    this.serviceFilterValue = '';
    this.store.dispatch(LobbyCheckInPageActions.serviceFilterValueChange({ filterValue: '' }));
  }

  keypress(event: KeyboardEvent) {
    if (event.key === '<' || event.key === '>' || event.key === '&') {
      event.preventDefault();
    }
  }

  EnableReceiveTextMessageCheckBox() {
    if (this.lobbyCheckInForm?.controls.PhoneNumber.invalid || this.lobbyCheckInForm?.controls.PhoneNumber.pristine ||
      this.lobbyCheckInForm?.controls.PhoneNumber.value === '') {
      this.lobbyCheckInForm.controls.RecieveTextMessage.disable();
      this.lobbyCheckInForm.controls.RecieveTextMessage.setValue(false);
    } else {
      this.lobbyCheckInForm.controls.RecieveTextMessage.enable();
    }
  }

  routeToLobbyAppointmentStatus() {
    if (this.lobbyCheckInForm.dirty) {
      const dialog = this.dialogService.open({
        content: ModalPopupImplComponent,
      });

      const subscription = dialog.result.subscribe(
        (result: any) => {
          if (result instanceof DialogCloseResult) {
          } else {
            if (result["primary"]) {
              this.close();
              this.router.navigateByUrl('/lobby/lobby-view', { state: { tab: LobbyTab.Appointment_Status } })
            }
          }
          subscription.unsubscribe();
        });
    } else {
      this.close();
      this.router.navigateByUrl('/lobby/lobby-view', { state: { tab: LobbyTab.Appointment_Status } })
    }
  }

  addToLobby(event: Event) {
    if (this.lobbyCheckInForm.valid) {
      if (this.lobbyCheckInForm.dirty) {
        this.impersonateInstantAssist = false;
        // Copy over all of the original product properties
        // Then copy over the values from the form
        // This ensures values not on the form, such as the Id, are retained
        const lobbyEntry = { ...this.lobbyCheckIn, ...this.lobbyCheckInForm.value };
        lobbyEntry.AccountNumber = this.accountNumberValue;
        lobbyEntry.CustomFieldValues = (this.lobbyConfiguration.EnableCustomField) ? { 1: this.lobbyCheckInForm.value.CustomFieldValues } : {};
        lobbyEntry.PreferredLanguage = parseInt(this.lobbyCheckInForm.value.PreferredLanguage);

        if (this.lobbyCheckInForm.value.UserRequested !== '-1') {
          if (this.lobbyCheckInForm.value.UserRequested.isNotificationGroup) {
            lobbyEntry.GroupRequested = parseInt(this.lobbyCheckInForm.value.UserRequested.userId, undefined);
            lobbyEntry.UserRequested = null;
          }
          else {
            lobbyEntry.UserRequested = parseInt(this.lobbyCheckInForm.value.UserRequested.userId, undefined);
          }

        } else {
          if (this.lobbyConfiguration.MakeStaffMemberSelectionMandatory) {
            this.staffMemberRequiredMessage = this.staffMemberRequirdText;
            return;
          }

          lobbyEntry.UserRequested = null;
        }

  this.store.dispatch(LobbyCheckInPageActions.addToLobby({ lobbyCheckIn: lobbyEntry }));

      }


    }
  }
  instantImpersonateAssist() {
    if (this.lobbyCheckInForm.valid) {
      if (this.lobbyCheckInForm.dirty) {
        this.impersonateInstantAssist = true;
        this.currentLobbyEntry = this.getLobbyEntryValues();
        this.store.dispatch(LobbyStaffStatusActions.loadImpersonateUsers({ locationId: this._locationId,showPopUp:false }));
        this.store.dispatch(LobbyCheckInPageActions.loadInstantImpersonateAssist({ show: true }));
      }
    }
  }
  instantAssist() {  
    if (this.lobbyCheckInForm.valid) {
      if (this.lobbyCheckInForm.dirty) {
        this.impersonateInstantAssist = false;
        // Copy over all of the original product properties
        // Then copy over the values from the form
        // This ensures values not on the form, such as the Id, are retained
        const lobbyEntry = { ...this.lobbyCheckIn, ...this.lobbyCheckInForm.value };
        lobbyEntry.AccountNumber = this.accountNumberValue;
        lobbyEntry.CustomFieldValues = (this.lobbyConfiguration.EnableCustomField) ? { 1: this.lobbyCheckInForm.value.CustomFieldValues } : {};
        lobbyEntry.PreferredLanguage = parseInt(this.lobbyCheckInForm.value.PreferredLanguage);

        if (this.lobbyCheckInForm.value.UserRequested !== '-1') {
          if (this.lobbyCheckInForm.value.UserRequested.isNotificationGroup) {
            lobbyEntry.GroupRequested = parseInt(this.lobbyCheckInForm.value.UserRequested.userId, undefined);
            lobbyEntry.UserRequested = null;
          }
          else {
            lobbyEntry.UserRequested = parseInt(this.lobbyCheckInForm.value.UserRequested.userId, undefined);
          }
          
        } else {
          if (this.lobbyConfiguration.MakeStaffMemberSelectionMandatory) {
            this.staffMemberRequiredMessage = this.staffMemberRequirdText;
            return;
          }

          lobbyEntry.UserRequested = null;
        }

        this.store.dispatch(LobbyCheckInPageActions.instantAssist({ lobbyCheckIn: this.getLobbyEntryValues(), userId: this.signInUserId }));
      }
    }
  }
  getLobbyEntryValues(): any {
    const lobbyEntry = { ...this.lobbyCheckIn, ...this.lobbyCheckInForm.value };
    lobbyEntry.AccountNumber = this.accountNumberValue;
    lobbyEntry.CustomFieldValues = (this.lobbyConfiguration.EnableCustomField) ? { 1: this.lobbyCheckInForm.value.CustomFieldValues } : {};
    lobbyEntry.PreferredLanguage = parseInt(this.lobbyCheckInForm.value.PreferredLanguage);

    if (this.lobbyCheckInForm.value.UserRequested !== '-1') {
      if (this.lobbyCheckInForm.value.UserRequested.isNotificationGroup) {
        lobbyEntry.GroupRequested = parseInt(this.lobbyCheckInForm.value.UserRequested.userId, undefined);
        lobbyEntry.UserRequested = null;
      }
      else {
        lobbyEntry.UserRequested = parseInt(this.lobbyCheckInForm.value.UserRequested.userId, undefined);
      }
    } else {
      if (this.lobbyConfiguration.MakeStaffMemberSelectionMandatory) {
        this.staffMemberRequiredMessage = this.staffMemberRequirdText;
        return;
      }

      lobbyEntry.UserRequested = null;
    }
    return lobbyEntry;
  }



  public close() {
    this.serviceFilterValue = '';
    this.lobbyCheckInForm.reset();
    this.store.dispatch(LobbyCheckInPageActions.closeCheckInModal());
    this.cancelled.emit();
    this._dialogOpened = false;
    this.sorted=false;
    this.sortdedAscending=false;
    this.lobbyCheckInForm.patchValue({
      AccountNumber: ""
    });
  }

  public open() {
    this._dialogOpened = true;

  }

  private loadStaffMembers() {
    if (this.tenantId && this.tenantId > 0 && this.locationId && this.locationId > 0) {
      this.store.dispatch(LobbyCheckInPageActions.loadStaffMembers({ tenantId: this.tenantId, locationId: this.locationId, showInLobby: true }));
    }
  }

  private GenericValidator(): void {
    this.validationMessages = {
      FirstName: {
        required: this.translateService.instant('_General_User_First_Name_Required_Text_'),
        pattern: this.translateService.instant('_General_User_First_Name_Invalid_Text_')
      },
      LastName: {
        required: this.translateService.instant('_General_User_Last_Name_Required_Text_'),
        pattern: this.translateService.instant('_General_User_Last_Name_Invalid_Text_')
      },
      PhoneNumber: {
        pattern: this.translateService.instant('_General_User_Phone_Invalid_Text_')
      },
      EmailAddress: {
        invalidEmail: this.translateService.instant('_General_User_Email_Invalid_Text_')
      },
      CustomFieldValues: {
        required: `${this.lobbyConfiguration.CustomFieldText} ${this.translateService.instant('_General_Is_Required_Text_')}`,
        pattern: this.translateService.instant('_Lobby_Invalid_Comment_Ts_Text_')
      },
      Notes: {
        pattern: this.translateService.instant('_Lobby_Invalid_Note_Ts_Text_')
      },
      AccountNumber: {
        pattern: `${this.translateService.instant('_General_User_Invalid_Text_')} ${this.lobbyConfiguration.AccountNumberDisplayText}`
      },
      UserRequested: {
        required: this.translateService.instant('_General_Staff_Memeber_Required_Ts_Text_')
      },
    };

    this.SetDynamicValidation();

    // Define an instance of the validator for use with this form,
    // passing in this form's set of validation messages.
    this.genericValidator = new GenericValidator(this.validationMessages);
  }


  private SetDynamicValidation() {
    this.lobbyCheckInForm?.controls['CustomFieldValues'].setValidators(Validators.pattern(/^[^<>&]+$/));
    this.doStaffValidation();
  }

  ngOnChanges() {
    // this.GenericValidator();
  }


  get recieveTextMessage() {
    return this.lobbyCheckInForm.get('RecieveTextMessage');
  }
  get accountNumber() {
    return this.lobbyCheckInForm.get('AccountNumber');
  }


  accountNumberFocusOut() {
    this.accountNumberValue = this.accountNumber?.value;
    var maskingType = this.lobbyConfiguration.AccountNumberMaskingOption;
    var eMaskingType = maskingType == 'Full Masking' ? MaskingType.FULL : maskingType == 'Partial Masking' ? MaskingType.PARTIAL : MaskingType.NONE;
    this.lobbyCheckInForm.patchValue({
      AccountNumber: this.maskValue(this.accountNumberValue, eMaskingType)
    });

  }
  public prevenetSpaceAtBegining(event: KeyboardEvent) {
    // Prevent typing spaces as the first character
    const target = event.target as HTMLInputElement;
    if (target.selectionStart === 0 && (event.key === ' ' || event.key === 'Spacebar')) {
      event.preventDefault();
    }
  }
  onAccountNumberChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const newVal = target.value ?? '';
    // Update the form control value and mark as modified so the form is no longer pristine
    this.accountNumber?.setValue(newVal);
    this.isAccountNumberModified = true;
    this.accountNumber?.markAsDirty();
    this.accountNumber?.markAsTouched();
    this.lobbyCheckInForm.markAsDirty();

    // If user clears the field, remove any duplicate error so the form can become valid
    if (!newVal || !newVal.trim()) {
      const errs = this.accountNumber?.errors;
      if (errs && (errs as any).duplicate) {
        const { duplicate, ...rest } = errs as any;
        this.accountNumber?.setErrors(Object.keys(rest).length ? rest : null);
      }
    }
  }
  maskValue(value: string, type: MaskingType) {
    switch (type) {
      case MaskingType.NONE:
        return value;

      case MaskingType.FULL:
        return value.replace(/./g, '*');

      case MaskingType.PARTIAL:
        return this.masker.mask(value);
    }
  }
  closeAccountMemberPopup() {
    this.isAccountMemberPopupVisible = false;
  }
  private doStaffValidation() {
    var staff = this.lobbyCheckInForm.controls['UserRequested'];
    if (this.lobbyConfiguration && this.lobbyConfiguration.MakeStaffMemberSelectionMandatory && this.lobbyCheckInForm != undefined && this.lobbyCheckInForm.controls['UserRequested'].value == '-1') {
      this.staffMemberRequiredMessage= this.staffMemberRequirdText;
      staff.setErrors({ 'required': true });
    }
    else {
      this.staffMemberRequiredMessage = null;
      staff.clearValidators();
    }
    this.lobbyCheckInForm.updateValueAndValidity();
  }
  public sortServices() {
    this.sorted = true;
    this.sortdedAscending = !this.sortdedAscending;
    this.lobbyServices.sort((item1: any, item2: any) => this.compare(item1, item2));
  }
  public sortServicesClick() {

    this.lobbyServices.sort((item1: any, item2: any) => this.compare(item1, item2));
  }
  compare(item1: any, item2: any): number {
    let compValue = 0;

    if (!this.lobbyConfiguration.ShowCategoriesInLobby) {
      compValue = item1.service.name.localeCompare(item2.service.name, 'en', {
        sensitivity: 'base'
      });
    } else {
      compValue = item1.catName.localeCompare(item2.catName, 'en', {
        sensitivity: 'base'
      });
    }
    if (!this.sortdedAscending) {
      compValue = compValue * -1;
    }
    return compValue;
  }

  public isAccountNumberModified: boolean = false;

  onAccountNumberKeydown(): void {
    this.isAccountNumberModified = true;
    this.accountNumber?.markAsDirty();
    this.accountNumber?.markAsTouched();
    this.lobbyCheckInForm.markAsDirty();
    try {
      this.cdr.detectChanges();
      this.appRef.tick();
    } catch (e) {
    }
  }
}
